<div class="date-box"><span class="day" v-if="day">{{day}}</span><span class="month" v-if="month">{{month}}</span></div>